import { isDefined } from '../is-defined';

export interface QueryParams {
  readonly [param: string]: unknown;
}

export function objectToQueryString(params: QueryParams, url = '', encode = true): string {
  const queryString = Object.keys(params)
    .filter((key) => isDefined(params[key]))
    .map((key) => encode
      ? `${encodeURIComponent(key)}=${encodeURIComponent(String(params[key] as string | number | boolean))}`
      : `${key}=${String(params[key] as string | number | boolean)}`)
    .join('&');

  return `${url}?${queryString}`;
}
